export const LedgerHeader = [
  {
    title: "Sl.no",
    key: "slno",
  },

  {
    title: "Date & Time",
    key: "createdDate",
    minWidth: 180,
  },
  {
    title: "Description",
    key: "description",
    minWidth: 140,
  },
  {
    title: "Transaction ID",
    key: "ledgerTransactionId",
    minWidth: 100,
  },
  {
    title: "Transaction Type",
    key: "ledgerTransactionType",
    minWidth: 120,
  },
  {
    title: "Transaction Amount",
    key: "ledgerTransactionAmount",
    minWidth: 100,
  },
  {
    title: "Closing Balance",
    key: "closingBalance",
    minWidth: 80,
  },
];

export const SettlementHeader = [
  {
    title: "2021",
    key: "year",
  },
  {
    title: "Total Fee's",
    key: "fees",
    minWidth: 180,
  },

  {
    title: "Export",
    key: "export",
    minWidth: 120,
  },
];

export const PayOutHeaders = [
  {
    title: "Sl.no",
    key: "slno",
  },
  {
    title: "Date & Time",
    key: "createdDate",
    minWidth: 180,
  },
  {
    title: "Description",
    key: "vanDescription",
    minWidth: 140,
  },
  {
    title: "UTR",
    key: "transferUniqueNo",
    minWidth: 120,
  },
  {
    title: "Order ID",
    key: "orderId",
    minWidth: 100,
  },
  {
    title: "Van",
    key: "beneAccountNo",
    minWidth: 100,
  },
  {
    title: "Txn Type",
    key: "transferType",
    minWidth: 80,
  },
  {
    title: "Amount",
    key: "transferAmt",
    minWidth: 150,
  },
  {
    title: "Fees",
    key: "payoutCommission",
    minWidth: 120,
  },
  {
    title: "Tax",
    key: "tax",
    minWidth: 60,
  },
  {
    title: "Status",
    key: "payinStatus",
    minWidth: 60,
  },
  {
    title: "Details",
    key: "payinViewMore",
    minWidth: 60,
  },
];

export const VanHeader = [
  {
    title: "Sl.no",
    key: "slno",
  },
  {
    title: "Date & Time",
    key: "createdDate",
    minWidth: 180,
  },
  {
    title: "Description",
    key: "description",
    minWidth: 140,
  },
  {
    title: "UTR",
    key: "transferUniqueNo",
    minWidth: 120,
  },
  {
    title: "Van",
    key: "beneAccountNo",
    minWidth: 100,
  },
  {
    title: "Txn Type",
    key: "transferType",
    minWidth: 80,
  },
  {
    title: "Amount",
    key: "transferAmt",
    minWidth: 150,
  },
  {
    title: "Fees",
    key: "commission",
    minWidth: 120,
  },
  {
    title: "Tax",
    key: "tax",
    minWidth: 60,
  },
];

export const PayInHeader = [
  {
    title: "Sl.no",
    key: "slno",
  },
  {
    title: "Date & Time",
    key: "createdDate",
  },
  {
    title: "Description",
    key: "vanDescription",
    minWidth: 140,
  },
  {
    title: "UTR (NK)",
    key: "payInTxnId",
    minWidth: 120,
  },
  {
    title: "Bank UTR",
    key: "transferUniqueNoPayIn",
    minWidth: 120,
  },

  {
    title: "Van",
    key: "beneAccountNo",
    minWidth: 100,
  },
  // {
  //   title: "Txn Type",
  //   key: "transferType",
  //   minWidth: 80,
  // },
  {
    title: "Transfer Type",
    key: "transferType",
    minWidth: 80,
  },
  {
    title: "Amount",
    key: "transferAmt",
    minWidth: 150,
  },
  // {
  //   title: "Fees",
  //   key: "commission",
  //   minWidth: 120,
  // },
  // {
  //   title: "Tax",
  //   key: "payInTax",
  // },
  {
    title: "Charges",
    key: "payInCharge",
  },
  {
    title: "Net Amount",
    key: "payInNetAmount",
  },
  {
    title: "Status",
    key: "payinStatus",
    minWidth: 60,
  },
  {
    title: "Details",
    key: "payinViewMore",
    minWidth: 60,
  },
];

export const CustomerHeader = [
  {
    title: "Sl.no",
    key: "slno",
  },
  {
    title: "Customer Name",
    key: "customerName",
  },
  {
    title: "Mobile Number",
    key: "customerMobileNumber",
  },
  {
    title: "Virtual ID",
    key: "customerVirtualId",
  },
  {
    title: "UPI ID",
    key: "customerUpiId",
  },
  {
    title: "Action",
    key: "customerAction",
  },
];

export const BeneficiaryHeader = [
  {
    title: "Sl.no",
    key: "slno",
  },
  {
    title: "Beneficiary Name",
    key: "beneficiaryName",
  },
  {
    title: "Bank account No",
    key: "beneAccountNumber",
  },
  {
    title: "IFSC Code",
    key: "ifscCode",
  },
  {
    title: "Action",
    key: "beneficiaryAction",
  },
];

export const CustomerTransactionHeader = [
  {
    title: "Sl.no",
    key: "slno",
  },
  {
    title: "Date & Time",
    key: "createdDate",
    minWidth: 180,
  },
  {
    title: "UTR",
    key: "customerTransferUniqueNo",
    minWidth: 120,
  },
  {
    title: "VPA",
    key: "customerBeneAccountNo",
    minWidth: 100,
  },
  {
    title: "Txn Type",
    key: "customerTransferType",
    minWidth: 80,
  },
  {
    title: "Amount",
    key: "customerTransferAmt",
    minWidth: 150,
  },
  {
    title: "Fees",
    key: "commission",
    minWidth: 120,
  },
  {
    title: "Tax",
    key: "tax",
    minWidth: 60,
  },
];

export const beneficiaryTransactionHeader = [
  {
    title: "Sl.no",
    key: "slno",
  },
  {
    title: "Date & Time",
    key: "createdDate",
    minWidth: 180,
  },
  {
    title: "UTR",
    key: "txnId",
    minWidth: 120,
  },
  {
    title: "Txn Type",
    key: "transferType",
    minWidth: 80,
  },
  {
    title: "Amount",
    key: "transferAmt",
    minWidth: 150,
  },
  {
    title: "Fees",
    key: "commission",
    minWidth: 120,
  },
  {
    title: "Tax",
    key: "tax",
    minWidth: 60,
  },
];
